/*eslint-env node*/
"use strict";

/****************************/
/* Kaltura video service helper functions */
/* Usage: queue video using queueVideoForLoading() in your template and call once init() in your main script */
/* In your HTML you will need container elements with id= videoId + "kaltura-video" */
/****************************/

var _ = require("underscore");
var $ = require("jquery");

var KALTURA_URL = "https://www.kaltura.com/p/2027791/sp/202779100/embedIframeJs/uiconf_id/32676902/partner_id/2027791";
var KALTURA_UICONF_ID = '32676902';
var KALTURA_HEIGHT = "393";
var KALTURA_PREFERRED_FLAVOR = "1600";

var JSContext = require('./jscontext');

var _isKalturaLoaded = function(){
    return JSContext.isKalturaLoaded();
};

var _loadKalturaScript = function(callback) {
    /* Check if Kaltura loaded, otherwise fetch and execute the script */
    if (!_isKalturaLoaded()) {
        $.getScript(KALTURA_URL)
        .done(function() {
            if(_.isFunction(callback)){
                JSContext.setKalturaLoaded(true);
                callback();
            }
        });
    } else {
        if(_.isFunction(callback)){
            callback();
        }
    }
};

/**
 * Creates kWidget embeded iframe player
 *
 * @param {string} videoId - ex: 0_e4dg4znq
 * @param {string} kalturaPartnerId
 * @param {string} targetId - element id: #my-kaltura-vid
 */
var _embedVideo = function(videoId, kalturaPartnerId, targetId) {
    /* load video using the Kaltura library object */
    window.kWidget.embed({
        'targetId': targetId,
        'wid': '_' + kalturaPartnerId,
        'entry_id': videoId,
        'uiconf_id': KALTURA_UICONF_ID,
        'width': '100%',
        'height': KALTURA_HEIGHT,
        'flashvars': {
            "logo": {
                "cssClass": "kaltura-player-logo"
            },
            'sourceSelector': {
                'plugin': true,
                'switchOnResize': false,
                'simpleFormat': true,
                'displayMode': 'size'
            },
            'mediaProxy.preferedFlavorBR': KALTURA_PREFERRED_FLAVOR
        }
    });
};

var _initVideosInQueue = function(callback){
    var kalturaPartnerId = JSContext.getKalturaPartnerId();
    var kalturaVideosQueue = JSContext.getKalturaVideosQueue();

    /* Loop throught the videos queue and load each one and then pop it from the queue */
    _.forEach(kalturaVideosQueue, function(videoId){
        _embedVideo(videoId, kalturaPartnerId, videoId + "-kaltura-video");
        _unQueueVideo(videoId);
    });
    if(_.isFunction(callback)){
        callback();
    }
};

/**
 * Attach the kalturaVideosQueue to window and push video to queue
 *
 * @param {string} videoId - ex: 0_e4dg4znq
 */
var queueVideoForLoading = function(videoId){
    /* If the video queue does not exist or it is not an array, declare it */
    var queue = JSContext.getKalturaVideosQueue();
    if(!queue || !_.isArray(queue)) {
        queue = [];
    }
    queue.push(videoId);
    JSContext.setKalturaVideosQueue(queue);
};

var _unQueueVideo = function(videoId){
    JSContext.setKalturaVideosQueue(
        _.reject(JSContext.getKalturaVideosQueue(), function(id){ return id === videoId; })
    );
};

/**
 * Load the Kaltura API script and trigger callback on completion
 *
 * @param {function} callback
 *
 */
var init = function(callback){
    _loadKalturaScript(_initVideosInQueue.bind(this, callback));
};

module.exports.init = init;
module.exports.queueVideoForLoading = queueVideoForLoading;



//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Lib1ThemeBuild/Platforms/1804Build/~/poly-js-utils/src/kaltura-helpers.js
// module id = 327
// module chunks = 8